import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Login from "../screens/Login/index";
import DashboardRoFood from "../screens/DashboardRoFood";
import DashboardMariOlivia from "../screens/DashboardMariOlivia";

const ProtectedRoute = ({ children }) => {
	return localStorage.getItem("token") ? children : <Navigate to="/login" replace />;
};

const App = () => (
	<BrowserRouter>
		<Routes>
			<Route path="/" element={<Login />} />
			<Route path="/login" element={<Login />} />
			<Route
				path="/dashboardRoFood"
				element={
					<ProtectedRoute>
						<DashboardRoFood />
					</ProtectedRoute>
				}
			/>
			<Route
				path="/dashboardMariOlivia"
				element={
					<ProtectedRoute>
						<DashboardMariOlivia />
					</ProtectedRoute>
				}
			/>
		</Routes>
	</BrowserRouter>
);

export default App;
